<template>
  <main role="main" class="py-4">
    <b-container>
      <div class="d-flex flex-row align-items-center justify-content-between mb-4">
        <h4 class="m-0">{{ $t("meetingCountTotal") }}</h4>
        <div>
          <!-- <b-button variant="outline-secondary" @click="onClickReloadBtn">
            <b-icon icon="arrow-clockwise"></b-icon> {{ $t("reload") }}
          </b-button> -->
        </div>
      </div>

      <b-form class="d-flex flex-row align-items-center mb-3" @submit.prevent="onClickSearchBtn">
        <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
          <div class="flex-shrink-0 mr-3"> {{ $t("fromDate") }}</div>
          <b-form-datepicker v-model="startDate" value-as-date required
                             :max="endDate ? endDate: new Date()"
                             no-flip hide-header
                             label-no-date-selected="DD/MM/YYYY"
                             locale="vi"
                             :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                             start-weekday="1"></b-form-datepicker>
        </div>
        <div class="flex-grow-1 d-flex flex-row align-items-center mr-3">
          <div class="flex-shrink-0 mr-3">{{ $t("toDate") }}</div>
          <b-form-datepicker v-model="endDate" value-as-date required
                             :min="startDate ? startDate: new Date()"
                             no-flip hide-header
                             label-no-date-selected="DD/MM/YYYY"
                             locale="vi"
                             :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                             start-weekday="1"></b-form-datepicker>
        </div>
        <b-button type="submit" variant="primary">{{ $t("apply") }}</b-button>
      </b-form>

      <b-table ref="table" :items="tableItemProvider" hover primary-key="id" :fields="tableFields" :busy="isLoading" show-empty
               :per-page="itemsPerPage" :current-page="currentPage">
        <template v-slot:table-busy>
          <div class="text-center text-secondary py-4">{{ $t("loadingData") }}</div>
        </template>
        <template v-slot:empty>
          <div class="text-center text-secondary py-4">{{ $t("noData") }}</div>
        </template>
        <template v-slot:cell(name)="data">
          <router-link :to="'/customers/details/' + data.item.customerId + '/meetings'">
            {{ data.item.name }}
          </router-link>
        </template>
      </b-table>

    </b-container>
  </main>
</template>

<style lang="scss" scoped>

</style>

<script lang="ts">
  import {Component, Ref, Vue} from 'vue-property-decorator';
  import _ from "lodash";
  import moment from "moment";
  import BaseComponent from "@/components/BaseComponent";
  import {BvTableFieldArray} from "bootstrap-vue";
  import {BTable, BvTableCtxObject, BvTableProviderPromiseResult} from "bootstrap-vue/src/components/table";
  import * as reportService from "@/service/reportService";
 import {formatDateRange}  from "@/service/util";
  @Component
  export default class MeetingCountTotal extends BaseComponent {

    startDate: Date = null;
    endDate: Date = null;
    formErrorMsg = "";
    isLoading = false;

    @Ref("table") table: BTable;
    tableFields: BvTableFieldArray = [
      {
        key: "fromDate",
        label:  this.$t("fromDate").toString(),
        thClass: "text-nowrap",
        formatter: value => moment(value).format("DD/MM/YYYY")
      },
      {
        key: "toDate",
        label: this.$t("toDate").toString(),
        thClass: "text-nowrap",
        formatter: value => moment(value).format("DD/MM/YYYY")
      },
      {
        key: "meetingEnded",
        label: this.$t("done").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "meetingInProgress",
        label: this.$t("inprogress").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "meetingPending",
        label: this.$t("pending").toString(),
        thClass: "text-nowrap",
      },
      {
        key: "meetingCancelled",
        label: this.$t("cancelled").toString(),
        thClass: "text-nowrap",
      },
    ];

    itemsPerPageSelections = [
      { value: 20, text: "20 " + this.$t("itemsPerPage").toString() },
      { value: 50, text: "50 " + this.$t("itemsPerPage").toString() },
      { value: 100, text: "100 " + this.$t("itemsPerPage").toString() },
      { value: 200, text: "200 " + this.$t("itemsPerPage").toString() },
    ];
    itemsPerPage = 20;
    currentPage = 1;
    totalItems = 0;


    mounted() {
      this.startDate = moment().subtract(30, "days").startOf("day").toDate();
      this.endDate = moment().endOf("day").toDate();
    }

    onClickReloadBtn() {
      this.startDate = moment().subtract(30, "days").startOf("day").toDate();
      this.endDate = moment().endOf("day").toDate();
      this.formErrorMsg = "";
      this.itemsPerPage = 20;
      this.currentPage = 1;
      this.totalItems = 0;

      this.table.refresh();
    }

    onClickSearchBtn() {
      this.table.refresh();
    }

    async tableItemProvider(ctx: BvTableCtxObject): Promise<BvTableProviderPromiseResult> {
      try {
        const { fromDate, toDate } = formatDateRange(this.startDate, this.endDate);
        console.log(fromDate, toDate);
        const customerListRes = await reportService.getMeetingsCountDetails(
        fromDate, toDate
        );

        this.totalItems = 1;
        return [customerListRes];

      } catch (e) {
        this.toastError(e);
        return [];
      }
    }

  }
</script>
